import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type JobsTableColumnsViewModel } from '@/features/jobs/list/JobsTableColumnsViewModel'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import {
  ColumnControls,
  TableControls,
} from '@/features/jobs/list/components/JobManagement/JobsViewerHeader/TableControls'

export interface TableControlsContainerProps {
  vm: JobManagementViewModel
  button: ReactNode
}

export const TableControlsContainer = observer(function TableControlsContainer({
  vm,
  button,
}: TableControlsContainerProps) {
  return (
    <TableControls
      button={button}
      onExportCsv={vm.columnsVm.exportJobsAsCSV}
      onManageColumns={vm.columnsVm.toggleColumnManager}
      canNotifyPros={vm.canNotifyProsOfUnclaimedJobs}
      onNotifyPros={vm.notifyProsOfUnclaimedJobsVm.modal.show}
      selectedCount={vm.selectionVm.selectedJobs.size}
      archiveRestoreAction={vm.selectionVm.permittedArchiveRestoreAction}
      onArchiveRestore={vm.selectionVm.archiveRestoreJobs}
      canClone={vm.selectionVm.canCloneJobs}
      onClone={vm.selectionVm.cloneJobs}
      canTransfer={vm.selectionVm.canTransferJobs}
      onTransfer={vm.selectionVm.transferJobs}
      canAdvance={vm.selectionVm.canAdvanceJobs}
      onAdvance={vm.selectionVm.advanceJobsVm.show}
      density={vm.columnsVm.density}
      onDensityChange={vm.columnsVm.setDensity}
      columnControls={<ColumnControlsContainer vm={vm.columnsVm} />}
    />
  )
})

export interface ColumnControlsContainerProps {
  vm: JobsTableColumnsViewModel
}

export const ColumnControlsContainer = observer(
  function ColumnControlsContainer({ vm }: ColumnControlsContainerProps) {
    return (
      <ColumnControls
        isOpen={vm.columnManagerOpen}
        onRequestClose={vm.closeColumnManager}
        allColumnsVisible={vm.allColumnsVisible}
        onToggleAllColumns={vm.toggleAllColumnVisibility}
        columns={vm.filteredColumns.map((column) => ({
          id: column.id,
          header: column.header,
          visible: column.visible,
          modifyVisibility: column.modifyVisibility,
          actionSelector: column.actionSelector,
        }))}
        onToggleColumn={vm.toggleColumnVisibility}
        onReorderColumn={vm.updateColumnOrder}
      />
    )
  },
)
